import React, { useMemo } from 'react';

import useClassy from '@core/hooks/useClassy';
import { useSuperHubStore, useAPIDesignerStore } from '@core/store';
import { isReferencePage, isChangelog } from '@core/store/SuperHub/Document/util';
import { isBranch } from '@core/store/SuperHub/util';

import Button from '@ui/Button';
import Flex from '@ui/Flex';
import Icon from '@ui/Icon';

import { useSuperHubEditorFormContext } from '../../Context';

import styles from './index.module.scss';

/**
 * The bottom sticky footer which contains form actions like "Save".
 */
export default function LayoutFooter() {
  const bem = useClassy(styles, 'SuperHubEditorFormLayoutFooter');

  const apiDesignerErrors = useAPIDesignerStore(s => s.errors);
  const [isViewingBranch, isSavingDisabled] = useSuperHubStore(s => [
    isBranch(s.currentBranch),
    s.editor.isSavingDisabled,
  ]);
  const {
    formState: { isDirty, isSubmitting, defaultValues },
  } = useSuperHubEditorFormContext();

  const isViewingChangelog = isChangelog(defaultValues);
  const hasApiDesignerError = useMemo(
    () => isReferencePage(defaultValues) && !!Object.keys(apiDesignerErrors).length,
    [apiDesignerErrors, defaultValues],
  );

  return (
    <div className={bem('&')}>
      <Flex align="center" gap="sm">
        {!!isViewingChangelog && !!isViewingBranch && (
          <Flex align="center" className={bem('-warning')} gap="xs">
            <Icon aria-hidden="true" className={bem('-warning-icon')} name="info" /> Changelogs aren’t versioned. Any
            changes are live immediately.
          </Flex>
        )}

        <Button
          disabled={isSavingDisabled || !isDirty || hasApiDesignerError}
          loading={isSubmitting}
          size="sm"
          type="submit"
        >
          Save
        </Button>
      </Flex>
    </div>
  );
}
